// ==========================================
// frontend/src/pages/About.jsx
import React from "react";
import AboutInfo from "../components/AboutInfo";
import { FaHistory, FaEye, FaBullseye } from "react-icons/fa";

const About = () => {
  return (
    <div className="py-12 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            À Propos de Nous
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Découvrez qui nous sommes et ce qui nous anime
          </p>
        </div>

        {/* Hero Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
              SE Engineering - Votre Partenaire en Ingénierie
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-4">
              SE Engineering est spécialisée dans la conception des solutions
              d'ingénierie innovantes, personnalisées et sur mesure. Basée à
              Ksibet El Mediouni, en Tunisie, nous mettons notre savoir-faire au
              service de nos clients afin de concrétiser leurs idées.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Nous mettons à profit nos compétences techniques, notre créativité
              et notre engagement en tant que professionnels qualifiés pour
              livrer des projets d'excellence qui dépassent les attentes de nos
              clients.
            </p>
          </div>
        </div>

        {/* Notre engagement */}
        <div className="mb-12">
          <AboutInfo />
        </div>

        {/* Mission, Vision, Valeurs */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
              <FaBullseye className="text-blue-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              Notre Mission
            </h3>
            <p className="text-gray-600 text-center">
              Fournir des solutions d'ingénierie innovantes et de haute qualité
              qui répondent aux besoins spécifiques de chaque client, en
              garantissant excellence et satisfaction.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
              <FaEye className="text-blue-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              Notre Vision
            </h3>
            <p className="text-gray-600 text-center">
              Devenir le leader régional en solutions d'ingénierie, reconnu pour
              notre innovation, notre qualité et notre approche centrée sur le
              client.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
              <FaHistory className="text-blue-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              Nos Valeurs
            </h3>
            <p className="text-gray-600 text-center">
              Excellence, intégrité, innovation et engagement envers nos clients
              sont au cœur de tout ce que nous faisons.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-lg p-12 text-center">
          <h2 className="text-3xl font-bold mb-4">Travaillons Ensemble</h2>
          <p className="text-xl mb-8 text-blue-100">
            Prêt à démarrer votre prochain projet avec nous ?
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Contactez-nous
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
